module.exports = __webpack_public_path__ + "wow.4cd719182f2538754df0.png";


//////////////////
// WEBPACK FOOTER
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/assets/wow.png
// module id = ../../../../../src/assets/wow.png
// module chunks = main